import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { StepTitle } from '../StepTitle';
import { StepIndicatorStates } from 'components/StepIndicator';
import { useIntl } from 'react-intl';
import { Contract } from 'modules/contract/types';
import { FindContractStepActive } from './FindContractStepActive';
import { FindContractHelpDrawer } from './FindContractHelpDrawer';
import { FindContractStepCompleted } from './FindContractStepCompleted';

interface FindContractStepProps {
  state: StepIndicatorStates,
  contract?: Contract,
  completeStep(selectedContract: Contract): void,
  onEditStep(): void
}

export const FindContractStep: React.FC<FindContractStepProps> = ({ state, contract, completeStep, onEditStep }) => {
  const { formatMessage } = useIntl();
  const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState<boolean>(false);

  return (
    <>
      <Stack>
        <StepTitle
          number={1}
          state={state}
          activeTitle={formatMessage({ id: 'FindContractStep.ActiveTitle', defaultMessage: 'Enter your contract and client number' })}
          completedTitle={formatMessage({ id: 'FindContractStep.CompletedTitle', defaultMessage: 'Contract and client number' })}
          incompleteTitle=""
          onHelpClick={() => setIsHelpDrawerOpen(true)}
          onEditClick={onEditStep}
        />
        {state === 'active' &&
          <FindContractStepActive completeStep={completeStep} />
        }
        {contract && state === 'complete' &&
          <FindContractStepCompleted contract={contract} />
        }
      </Stack >
      <FindContractHelpDrawer open={isHelpDrawerOpen} onClose={() => setIsHelpDrawerOpen(false)} />
    </>
  );
};